import * as types from './constants';

const initialState = {
  data: {},
  saveLoading: false,
  errors_api: {}
};

const actions = {
  // Edit Account Email
  [types.EDIT_ACCOUNT_EMAIL_REQUEST]: state => {
    const data = {
      ...state,
      saveLoading: true
    };

    return { ...data };
  },

  [types.EDIT_ACCOUNT_EMAIL_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      saveLoading: false,
      data: payload
    };

    return { ...data };
  },

  [types.EDIT_ACCOUNT_EMAIL_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      saveLoading: false,
      errors_api: payload
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};